import type {TransactionFilters} from 'shared/src/models';

export const QueryCacheKeys = {
	categoryGroups: () => ['categoryGroups'],
	categories: () => ['categories'],
	customer: (id: string | null | undefined) => ['customers', id],
	customers: () => ['customers'],
	customerInvoices: (customerId: string | null | undefined) => ['customer', customerId, 'invoices'],
	customerProjects: (customerId: string | null | undefined) => [
		'customers',
		customerId,
		'projects',
	],
	files: () => ['files'],
	invoice: (id: string | null | undefined) => ['invoices', id],
	invoices: () => ['invoices'],
	notes: (ids: string[]) => ['notes'],
	paymentAccounts: () => ['paymentAccounts'],
	products: () => ['products'],
	project: (projectId: string) => ['projects', projectId],
	projectFiles: (projectIds: string[]) => ['projects', 'files', ...projectIds],
	projects: () => ['projects'],
	tags: () => ['tags'],
	tagByInternalId: (internalId: string) => ['tags', internalId],
	transaction: (id: string) => ['transaction', 'id', id],
	transactions: (filters: TransactionFilters) => [
		'transactions',
		'startDate',
		filters.startDate,
		'endDate',
		filters.endDate,
		'categoryIds',
		filters.categoryIds?.sort(),
		'tagIds',
		filters.tagIds?.sort(),
		'excludedTagIds',
		filters.excludedTagIds?.sort(),
		'projectIds',
		filters.projectIds?.sort(),
		'includeDeleted',
		filters.includeDeleted,
	],
	trips: (year: number) => ['trips', year],
};
